import { ConcessaoVeiculo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity';
import { Horario } from '@tivic-team/manager-ts/dist/mob/entities/horario/horario.entity';
import { TabelaHorarioRota } from '@tivic-team/manager-ts/dist/mob/entities/horario/tabela-horario-rota.entity';
import { TabelaHorario } from '@tivic-team/manager-ts/dist/mob/entities/horario/tabela-horario.entity';
import { LinhaRota } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha-rota.entity';
import { Linha } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity';
import { TabelaHorarioRotaDTO } from './tabela-horario-rota.dto';

export class TabelaHorarioDTO extends TabelaHorario{

    linha: Linha = void(0);
    cdRotaIdaOld: number = void(0);
    cdRotaVoltaOld: number = void(0);
    linhaRotaIda: LinhaRota = void(0);
    linhaRotaVolta: LinhaRota = void(0);
    concessaoVeiculo: ConcessaoVeiculo = void(0);
    tabelaHorarioRotaIda: TabelaHorarioRota = void(0);
    tabelaHorarioRotaVolta: TabelaHorarioRota = void(0);
    
    horarios: Array<Horario> = void(0);
    horariosParadas: Array<TabelaHorarioRotaDTO>;
    
    constructor() {
        super();
    }

}

export class TabelaHorarioListDTO {

    items: Array<TabelaHorarioDTO>;
    total: number;

    constructor() {}

}